var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.1412V21.6281C21 20.2951 20.4732 19.0167 19.5355 18.0741C18.5979 17.1315 17.3261 16.6019 16 16.6019H6C4.67392 16.6019 3.40215 17.1315 2.46447 18.0741C1.52678 19.0167 1 20.2951 1 21.6281V24.1412",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5758C13.7614 11.5758 16 9.3255 16 6.54962C16 3.77373 13.7614 1.52344 11 1.52344C8.23858 1.52344 6 3.77373 6 6.54962C6 9.3255 8.23858 11.5758 11 11.5758Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountIcon);
export default __webpack_public_path__ + "static/media/my_account_icon.0a838863dd2a0e1b1147e8c189c45fed.svg";
export { ForwardRef as ReactComponent };